import styled from "styled-components";
import { styledByTheme } from "../../../themes/architecture/styled-by-theme";

const ProfileMessagesDividerDefaultBox = styled.div`
    flex: 1;
    max-width: 1px;
    background: transparent;
`;

const ProfileMessagesDividerCasino777Box = styled(ProfileMessagesDividerDefaultBox)`
    background: #000000;
`;

const ProfileMessagesDividerHarrahsWsopBox = styled(ProfileMessagesDividerDefaultBox)`
    background: ${({theme}) => theme.colors.boxBorder}; /* bodyBackground, userMenuBalanceBorder */
`;

export const ProfileMessagesDividerBox = styledByTheme(ProfileMessagesDividerDefaultBox)
    .forCasino777(ProfileMessagesDividerCasino777Box)
    .forHarrahs(ProfileMessagesDividerHarrahsWsopBox)
    .forWsop(ProfileMessagesDividerHarrahsWsopBox)
    .apply();
